<template>
  <component
    :is="component"
    :class="$style.root"
    variant="link"
    v-bind="$attrs"
    v-on="$listeners"
    @click.stop
  >
    <slot />
  </component>
</template>

<script>

import Typography from '../Typography'

export default {
  name: 'Link',

  components: { Typography },

  computed: {
    component () {
      return this.$attrs.to
        ? 'router-link'
        : 'a'
    }
  }
}

</script>

<style module>

.root {
	@apply 
		font-medium
		text-primary
		cursor-pointer;
}

.root:global(.router-link-active) {
	@apply 
		text-primary;
}

</style>
